import Icon from './Icon';

const EmptyCheckbox = (props) => {
  const {
    color,
    fillColor = 'var(--color-base-1)',
    strokeWidth = 1,
    ...rest
  } = props;
  return (
    <Icon {...rest} viewBox="0 0 24 24">
      <rect
        x="1"
        y="1"
        width="20"
        height="20"
        rx="3"
        fill={fillColor}
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </Icon>
  );
};

export default EmptyCheckbox;
